// Desktop (Web Notifications) + audible alert helpers for the command center.

let permissionAsked = false;

export function ensureNotifyPermission(): void {
  if (typeof Notification === 'undefined' || permissionAsked) return;
  permissionAsked = true;
  if (Notification.permission === 'default') {
    Notification.requestPermission().catch(() => {});
  }
}

export function desktopNotify(title: string, body?: string): void {
  try {
    if (typeof Notification === 'undefined') return;
    if (Notification.permission === 'granted') {
      new Notification(title, { body, tag: title });
    }
  } catch {
    // Notifications unsupported / blocked — silent.
  }
}

// Short attention tone via WebAudio (no asset). freq/type tuned per severity.
export function beep(kind: 'alert' | 'proximity' = 'alert'): void {
  try {
    const Ctx = window.AudioContext || (window as any).webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = kind === 'alert' ? 'square' : 'sine';
    osc.frequency.value = kind === 'alert' ? 780 : 560;
    gain.gain.value = 0.25;
    osc.start();
    setTimeout(() => {
      osc.stop();
      ctx.close();
    }, kind === 'alert' ? 500 : 250);
  } catch {
    // Audio unsupported — silent.
  }
}
